import { useMutation } from 'react-query';
import { authFetch } from '../../../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../../../CommonUtils/urlWithParams';
import { httpBodyOptions } from '../../../../../CommonUtils/httpBodyOptions';
import { AssetBucketingDetailsDTO } from './useAssetBucketingDetailsQuery';

interface Params extends AssetBucketingDetailsDTO {
  clientId: string;
}

const editAssetBucketing = ({ clientId, ...body }: Params) => {
  return authFetch(
    urlWithParams('/Consumer/AssetBucketingLayoutUpdate', {
      clientId,
    }),
    { method: 'POST', ...httpBodyOptions(body, true) },
  );
};

export const useEditAssetBucketingMutation = () => {
  return useMutation(editAssetBucketing);
};
